import { clsx } from "clsx";
import styles from "./AssetTypeTagLayout.module.scss";

export default function AssetTypeTagLayout({
  tags,
  className,
}: {
  tags: string[];
  className?: string;
}) {
  return (
    <div className={clsx(styles.container, className)}>
      {tags.map((tag) => (
        <div
          className={clsx(
            "vst-tag",
            "vst-tag-size-small",
            "vst-tag-option-ellipsis"
          )}
          key={tag}
        >
          {tag}
        </div>
      ))}
    </div>
  );
}
